@if (items.length > 0) {
  @for (item of items; track trackItemByFn(i, item); let i = $index) {
    @if (getControl(item) | async; as control) {
      <ng-container class="cx-item-list-items"
                  [class.is-changed]="
              featureConfigService?.isLevel('3.1')
                ? control.get('quantity').disabled
                : control.get('quantity').dirty">
        @if (!item.parent && !item.subEntry && (nomOfItemsToShow <= maxItemsToShow || i <= lastItemIndexToShow || showAllItems)) {
          <app-mini-cart-item [item]="item"
          [quantityControl]="control.get('quantity')"></app-mini-cart-item>
        }
      </ng-container>
    }
  }
} @else {
  <p class="text-empty-cart">{{ 'miniCart.miniCartDialog.emptyCart' | cxTranslate }}</p>
}

<div class="mini-cart-item-list-actions">
  @if (nomOfItemsToShow > maxItemsToShow) {
    <button class="btn btn-link btn-show-more" type="button" (click)="toggleShowMore()"
      >
      @if (!showAllItems) {
        {{ 'miniCart.miniCartDialog.actions.showMore' | cxTranslate }}
      } @else {
        {{ 'miniCart.miniCartDialog.actions.showLess' | cxTranslate }}
      }
    </button>
  }
</div>
<ng-template #loading>
  <cx-spinner></cx-spinner>
</ng-template>
